<agpr-dialog-container
    [id]="'alertLimitReachedDialog'"
    [showClose]="true"
    [contentPadding]="false"
    (close)="cancel()"
    [heading]="'Alerts.limitReached.dialog.header'"
>
    <div class="agpr-alertLimitReachedDialog">
        <div class="agpr-alertLimitReachedDialog-message">
            <agpr-message
                [severity]="messageSeverities.warning"
            >
                <div [innerHTML]="'Alerts.limitReached.dialog.message1' | localize : {alertLimit}"></div>
            </agpr-message>
        </div>

        <div class="agpr-alertLimitReachedDialog-message" [innerHTML]="'Alerts.limitReached.dialog.message2' | localize"></div>
    </div>
    <ng-template #footerRight>
        <agpr-button
            id="alertLimitReachedDialog.acknowledge"
            [label]="'Alerts.limitReached.dialog.acknowledge'"
            [style]="buttonTypes.primary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
